import { Record } from '../transit'

const ImageNote = new Record({
  path: '',
  reviewed: false,
}, 'imageNote')

export default ImageNote



// WEBPACK FOOTER //
// ./src/common/results/ImageNote.js